module.exports = __webpack_public_path__ + "media/images/proof_links/vine-5ad7f7876a4ffdb4d8188a2206f30446.svg";